export const MOCKUP_AI = {
  approximate_date: null,
  id: -1,
  time_created: '2025-05-05 12:21:55',
  timeCreated: '2025-05-05 12:21:55',
  created_by: 'Oleksandr Tokariev',
  description: `<p>Good day!</p><p>I see an increase in acceleration and Pk-Pk levels on the "DS Bearing" bearing. In the spectrum, I see an increase in vibration in the high-frequency range and an increase in floor noise, which is typical for mechanical friction or poor lubrication of the bearing. I recommend performing an ultrasound inspection of the "DS Bearing" bearing to detect potential defects and assessing the need for lubrication. Please let us know the results of your review. Best regards</p>`,
  equipment_type: 'mote',
  equipment_info: '52-304 Tunnel Dryer Supply Fan South Zone 2',
  facility: {
    name: 'Park500',
    timezone: {
      offset: 0,
    },
    currency: null,
  },
  installation_point: {
    id: -1,
    component: 'DS',
    point_type: 'sensor',
    name: 'DS Bearing',
    equipment_id: -1,
    equipmentId: -1,
    equipment: {
      id: -1,
      asset_code: 'PF2-20-14',
      location_id: -1,
      name: '52-304 Tunnel Dryer Supply Fan South Zone 2',
    },
    sensor_id: -1,
  },
  hasDescription: true,
  location_info: '2nd Floor Machine Room',
  sensor_id: -1,
  state: 10,
  wo_status: null,
  title: 'Review lubrication practices and ensure proper lubrication',
  type: 'regular' as const,
  urgency: 1,
  urgencyName: 'Standard' as const,
  wo_number: '95948036',
  is_no_actions: false,
  node: {
    activeWwrSensors: [],
  },
  translates: [],
  is_troubleshooting_hold: 0,
  serial: null,
  user_id: 1,
  is_replace_equipment: 0,
  remindDate: null,
  facilityOffset: 0,
  stateName: 'NEW' as const,
  technicalInfo: [''],
  equipmentName: '52-304 Tunnel Dryer Supply Fan South Zone 2',
  locationName: '2nd Floor Machine Room',
  instPointInfo: 'DS Bearing',
  descriptionInfo: '',
};
